// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});

// Flag global para evitar loops de refresh
let _refreshAttempted = false;

// Interceptor global: detectar sesión perdida silenciosamente
supabase.auth.onAuthStateChange(async (event, session) => {
  if (event === 'SIGNED_IN' || event === 'TOKEN_REFRESHED') {
    _refreshAttempted = false; // Reset flag on successful auth
    return;
  }
  if (!session && event !== 'SIGNED_OUT' && event !== 'INITIAL_SESSION') {
    if (_refreshAttempted) return; // Ya se intentó, no repetir
    _refreshAttempted = true;
    const { error } = await supabase.auth.refreshSession();
    if (error) {
      await supabase.auth.signOut();
      window.location.href = '/auth';
    }
  }
});